export default __webpack_public_path__ + "static/media/cakeshow1.a4897d7f.jpg";